import { mediumGreen, mediumGrey, orange, yellow } from '@styles/theme';
import { themeVars } from '@styles/themes.css';
import {
  createVar,
  fallbackVar,
  style,
  styleVariants,
} from '@vanilla-extract/css';

const iconFill = createVar();

const base = style({
  fontStyle: 'normal',
  lineHeight: 1,
  userSelect: 'none',
  fontFeatureSettings: "'liga'",
  WebkitFontFeatureSettings: "'liga'",
  WebkitFontSmoothing: 'antialiased',
  MozOsxFontSmoothing: 'grayscale',
  display: 'inline-block',
  fontVariationSettings: `'FILL' ${fallbackVar(iconFill, '0')}`,
});

export const variants = styleVariants({
  outlined: [base, { fontFamily: "'Material Symbols Outlined'" }],
  rounded: [base, { fontFamily: "'Material Symbols Rounded'" }],
  sharp: [base, { fontFamily: "'Material Symbols Sharp'" }],
});

export const sizes = styleVariants({
  xs: { fontSize: '1rem' },
  sm: { fontSize: '1.25rem' },
  md: { fontSize: '1.5rem' },
  lg: { fontSize: '1.875rem' },
  xl: { fontSize: '2.5rem' },
});

export const colors = styleVariants({
  inherit: { color: 'inherit' },
  primary: { color: themeVars.color.primary.main },
  error: { color: themeVars.color.error },
  success: { color: themeVars.color.success },
  mediumGrey: { color: mediumGrey },
  orange: { color: orange },
  yellow: { color: yellow },
  mediumGreen: { color: mediumGreen },
});

export const fills = styleVariants({
  outline: { vars: { [iconFill]: '0' } },
  filled: { vars: { [iconFill]: '1' } },
});
